import {setTriggerRebuildConnection} from 'stores/actions/appStateAction';
import {ApiRouteMap} from 'constants/dataEnum';
import {callAPI} from './commonBusiness';

export const getSoftwareReloadAttemptFromLocalStorage = () => {
  const key = 'reload';
  const value = window.localStorage.getItem(key);

  return value;
};

export const setSoftwareReloadAttemptFromLocalStorage = (newValue) => {
  const key = 'reload';
  let value;
  if (typeof newValue === 'number') {
    value = newValue;
  } else {
    value = getSoftwareReloadAttemptFromLocalStorage();
    value = (value ? Number(value) : 0) + 1;
  }
  window.localStorage.setItem(key, value);
};

export const rebuildHubConnections = () => async (dispatch, getState) => {
  const state = getState();
  const {configState} = state;

  // pooling
  setTimeout(async () => {
    let stopPoolingFlh = false;
    let stopPoolingFi = false;

    console.log('start pooling');

    const poolingInstance = setInterval(async () => {
      if (stopPoolingFlh && stopPoolingFi) {
        console.log('end pooling');
        clearInterval(poolingInstance);

        dispatch(setTriggerRebuildConnection(new Date().toString()));
        return;
      }

      try {
        if (!stopPoolingFi) {
          console.log('pooling - test connection - FI');

          const statusResponse = await callAPI(
            'GET',
            configState.hubHost.urlInstrumentControlLocation,
            ApiRouteMap.GET_INSTRUMENT_STATUS,
          );

          if (statusResponse) {
            stopPoolingFi = true;
          }
        }

        if (!stopPoolingFlh) {
          console.log('pooling - test connection - FLH');

          const statusResponse = await callAPI(
            'GET',
            configState.hubHost.urlAuthoringLocation,
            `api/Test/${ApiRouteMap.TEST_FLH}`,
          );

          if (statusResponse) {
            stopPoolingFlh = true;
          }
        }
      } catch (err) {
        console.log(err);
      }
    }, 2000);
  }, 30000);
};
